import GS from '../../grafsync/grafsync';
import SecondaryButton from '../../core/SecondaryButton';
import { UserConsumer } from '../providers/UserProvider';
import { Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withStyles, withTheme } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CancelButton from '../../core/CancelButton';
import BasicBackground from '../BasicBackground';
import { globalStyles as styles } from '../style/gstheme';
import BuySubscription from './BuySubscription';
import TellUsABitMore from './TellUsABitMore';

class FirstVisit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      monthly: true,
      stage: 0
    };
  }

  setSubscription = (subscription, refresh) => {
    this.props.begin();
    this.props.onSelectSubscription(subscription, refresh);
  };

  skip = () => this.setState({ stage: 1 });

  start = () => this.props.begin();

  monthly = () => this.setState({ monthly: true });

  yearly = () => this.setState({ monthly: false });

  render() {

    const { monthly } = this.state;
    const { classes, theme, onNewSubscription } = this.props;
    const subscriptionOptions = GS.subscriptionOptions();

    return (
      <BasicBackground>
        <div role="main" style={{ marginTop: 30, padding: 30, textAlign: 'center' }}>
          {this.state.stage === 0 ?
            <UserConsumer>
              {({ user, updateUser }) =>
                <div>
                  <Typography className={classes.accessHeadingHighlighted}>Tell Us a Bit More About Yourself</Typography>
                  <Paper elevation={0} style={{
                    width: 480,
                    padding: 30,
                    margin: '20px auto 0px auto'
                  }}>
                    <div style={{ textAlign: 'left' }}>
                      <TellUsABitMore user={user} updateUser={updateUser} done={this.skip} />
                    </div>
                    <div style={{ margin: '30px auto 0px auto' }}>
                      <CancelButton onClick={this.skip}>Skip</CancelButton>
                    </div>
                  </Paper>
                </div>
              }
            </UserConsumer>
            :
            <div>
              <Typography className={classes.accessHeadingHighlighted}>Vocabulary and Ontology Management</Typography>
              <Typography className={classes.mainHeadingLight}>Create a Subscription</Typography>
              <Paper elevation={0} style={{
                width: this.props.width === "md" || this.props.width === "lg" ?
                  860
                  :
                  this.props.width === "sm" ?
                    480
                    :
                    400
                , padding: 30, margin: '20px auto 0px auto'
              }}>
                <div style={{ margin: '0 auto' }}>
                  <Typography variant="body2" style={{ color: theme.palette.primary.main }}>By registering you have created an account.</Typography>
                  <Typography variant="body2" style={{ color: theme.palette.primary.main }}>You may have pending invites from subscription owners or you may want to create your own subscription.</Typography>
                  <Typography variant="body2" paragraph style={{ color: theme.palette.primary.main }}>All prices below are exclusive of any sales taxes.</Typography>
                </div>
                <div style={{ paddingTop: 10 }}>
                  <span style={{ marginRight: 10 }}>
                    <SecondaryButton disabled={monthly} onClick={this.monthly} className={classes.button}>Monthly</SecondaryButton>
                  </span>
                  <span style={{ marginLeft: 10 }}>
                    <SecondaryButton disabled={!monthly} onClick={this.yearly} className={classes.button}>Yearly</SecondaryButton>
                  </span>
                </div>
                <div style={{marginTop: 20}}>
                  <Typography variant="body2" paragraph style={{ color: '#CA4F0C' }}>Yearly prices give you the equivalent of one month free per year.</Typography>
                </div>
                <div style={{ marginTop: 22, display: 'flex', flexWrap: 'wrap', width: '100%', alignItems: 'center', justifyContent: 'center', }}>
                  {monthly && subscriptionOptions
                    .filter(option => !option.billing || option.billing === "Monthly")
                    .filter(option => !option.withdrawn)
                    .map((option, index) => {
                      const hasBorder = (index !== 4 && ["md", "lg"].includes(this.props.width))
                        || (index !== 1 && index !== 3 && index !== 4 && index < subscriptionOptions.length - 1 && ["xs", "sm"].includes(this.props.width));
                      return <div key={index} style={{ marginBottom: 20, ...(hasBorder) && { borderRight: 'solid 1px #e0e0e0' } }} >
                        <BuySubscription
                          onNewSubscription={onNewSubscription}
                          setSubscription={this.setSubscription}
                          name={option.value}
                          price={option.price}
                          dollarPrice={option.dollarPrice}
                          free={option.free}
                          billing={option.billing}
                          userCount={option.userCount} />
                      </div>;
                    })}
                  {!monthly && subscriptionOptions
                    .filter(option => option.billing === "Yearly")
                    .filter(option => !option.withdrawn)
                    .map((option, index) => {
                      const hasBorder = this.props.width !== 'xs' &&
                        ((index !== 3 && ["md", "lg"].includes(this.props.width))
                        || (index !== 1 && index !== 3 && index < subscriptionOptions.length - 1 && this.props.width === "sm"));
                      return <div key={index} style={{ marginBottom: 20, ...(hasBorder) && { borderRight: 'solid 1px #e0e0e0' } }} >
                        <BuySubscription
                          onNewSubscription={onNewSubscription}
                          setSubscription={this.setSubscription}
                          name={option.value}
                          price={option.price}
                          wide={true}
                          dollarPrice={option.dollarPrice}
                          free={option.free}
                          billing={option.billing}
                          userCount={option.userCount} />
                      </div>;
                    })}
                </div>
                <div style={{ margin: '30px auto 0px auto' }}>
                  <CancelButton onClick={this.start}>Continue to your account</CancelButton>
                </div>
              </Paper>
            </div>
          }
        </div>
      </BasicBackground >
    );
  }
}

FirstVisit.propTypes = {
  classes: PropTypes.object,
  begin: PropTypes.func.isRequired,
  width: PropTypes.string,
  theme: PropTypes.object,
  onNewSubscription: PropTypes.func.isRequired,
  onSelectSubscription: PropTypes.func.isRequired
};

export default withWidth()(withTheme(withStyles(styles)(FirstVisit)));